import React from 'react';

const WhyItWorksComponent = () => {
  return (
    <div className="bg-white">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        {/* Content centered without image */}
        <div className="w-full">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4">Why Roots & Wings Works for Investors</h2>
          
          <p className="text-gray-700 mb-4">
            This philosophy aligns perfectly with the real goals of most investors
            capital preservation plus meaningful growth.
            We don't rely on luck or market timing. We rely on quality businesses 
            and disciplined execution.
          </p>
          
          <p className="text-gray-700 mb-6">
            It's how we bring consistency to our portfolio management services (PMS) 
            and build trust as a SEBI registered investment advisor.
          </p>
          
          <div className="bg-blue-50 p-5 rounded">
            <p className="text-gray-800 italic">
              "In investing, what is comfortable is rarely profitable." – Robert Arnott
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyItWorksComponent;